import { render } from "./ChooseAddonProduct.vue?vue&type=template&id=8295466c&scoped=true"
import script from "./ChooseAddonProduct.vue?vue&type=script&lang=js"
export * from "./ChooseAddonProduct.vue?vue&type=script&lang=js"

import "./ChooseAddonProduct.vue?vue&type=style&index=0&id=8295466c&lang=scss&scoped=true"

import exportComponent from "/builds/nordhealth/projects/therapy/easypractice/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8295466c"]])

export default __exports__